module.exports = __webpack_public_path__ + "img/lasource-29.cb88e2be.jpg";